// server api
export const auth = `/v1/newsapp/comm/auth`
export const fqa = `/v1/newsapp/h5Encrypt/index?newsType=newsapp`
